<template>
  <div class="chat-overlay"  v-if="showChat" v-show="!minimized">
    <div class="modal fade show" v-if="showCloseConfirmation" tabindex="-1" role="dialog" style="display: block;">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Chat beenden</h5>
          </div>
          <div class="modal-body">
            <p class="mb-0">Möchten Sie den Chat wirklich beenden?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="handleCloseConfirmation(false)">
              Nein
            </button>
            <button type="button" class="btn btn-primary btn-chat" @click="handleCloseConfirmation(true)">
              Ja
            </button>
          </div>
        </div>
      </div>
    </div>
    <Transition name="fade">
      <div v-if="showNoUsersAlert" class="alert-message no-user-alert">
        <div class="alert alert-warning">
          Es sind keine anderen Benutzer im Raum. Ihre Nachricht kann nicht gesendet werden.
        </div>
      </div>
    </Transition>
    <Transition name="fade">
      <div v-if="webSocketStatus != 'connected'" class="alert-message websocket-alert">
        <div class="alert alert-warning">
          Die Verbindung zum Server ist unterbrochen. Bitte überprüfen Sie ihre Internetverbindung. Sie können keine Nachrichten senden / empfangen. <br />
        </div>
      </div>
    </Transition>
    <Transition name="fade">
      <div v-if="showUpdate" class="alert-message websocket-alert">
        <div class="alert alert-warning">
          Der Termin wurde vom Berater verlängert. Bitte schließen Sie den Chat und öffnen Sie ihn erneut.
        </div>
      </div>
    </Transition>
    <!-- <Transition name="fade">
      <div v-if="webSocketStatus == 'reconnecting'" class="alert-message websocket-alert">
        <div class="alert alert-warning">
          Es wird versucht die Verbindung wiederherzustellen.
        </div>
      </div>
    </Transition> -->
    <div class="overlay-container">
      <div class="overlay-chat-window d-flex">
        <div class="user-sidebar" :class="{ 'active': sidebarActive }">
          <div class="sidebar-header">
            <div class="d-flex align-items-center justify-content-between w-100">
              <h6  class="mb-0">Aktive Benutzer</h6>
              <div class="d-flex align-items-center">
                <span class="user-count me-2">{{ userList.length }}</span>
                <button class="hide-sidebar-btn d-md-none" @click="toggleSidebar">
                  <i class="bi bi-chevron-left"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="user-list">
            <!-- <div class="user-item current-user">
              <div class="user-icon">
                <i class="bi bi-person-fill"></i>
              </div>
              <span class="user-name">{{ username }}</span>
            </div> -->
            <div v-for="(user) in userList" :key="user.username" class="user-item">
              <div aria-hidden="true" class="user-icon">
                <i class="bi bi-person"></i>
              </div>
              <span class="user-name">{{ user.username }} ({{ user.userType == "ADVISOR" ? "Berater:in" : "Klient:in "
                }})
              </span>

            </div>
          </div>
        </div>

        <div class="sidebar-backdrop" :class="{ 'active': sidebarActive }" @click="toggleSidebar"></div>

        <div class="chat-main" >
          <div class="overlay-header d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <button class="sidebar-toggle d-md-none" @click="toggleSidebar">
                <i class="bi bi-list"></i>
              </button>
              <div aria-hidden="true" class="header-icon me-2">
                <i aria-hidden="true" class="bi bi-chat-fill"></i>
              </div>
              <h5  class="mb-0">Onlineberatung Chat</h5>
            </div>

            <div class="d-flex">
              <button class="btn-minimize me-2" @click="minimizeChat" title="Chat minimieren">
                <i class="bi bi-dash-lg"></i>
              </button>
              <button class="btn-close btn-close-white" @click="initiateClose"></button>
            </div>

            <div v-if="endsInFiveMinutes()" ref="endWarning" class="end-of-chat-warning">Hinweis: Der Termin endet bald. <span class="timer" ref="timer">05:00</span></div>
          </div>

          <div class="overlay-messages" ref="messagesContainer">
            <!-- <div class="message">
              <div class="d-flex mb-4">
                <div class="bot-icon me-2 align-self-start">
                  <i class="bi bi-headset"></i>
                </div>
                <div>
                  <div class="message-bubble mb-2">
                    <p class="mb-0">Willkommen bei der Onlineberatung!</p>
                  </div>
                </div>
              </div>
            </div> -->

            <div v-for="(message, index) in messages" :key="index"  :class="message.type">
              <div class="d-flex w-full mb-4" :class="message.type === 'own-user' ? 'justify-content-end' : 'justify-content-start' ">
                <div class="message-container" :class="getMessageCssClassForUser(message.sender)">
                  <template v-if="message.type !== 'system'">
                    <div class="me-2 align-self-start" >
                      <span>{{ message.sender }}</span>
                    </div>
                  </template>

                  <div v-if="message.replyTo" class="citation-wrapper mb-2">
                    <div class="citation-content">
                      <div class="citation-header">
                        <i class="bi bi-reply-fill me-1"></i>
                        <span class="citation-author">Antwort an {{ message.replyTo.sender }}</span>
                      </div>
                      <div v-dompurify-html="message.replyTo.text" class="citation-text"></div>
                    </div>
                  </div>

                  <div class="message-bubble-wrapper">
                    <div class="message-bubble">
                      <div v-dompurify-html="message.text"></div>
                    </div>
                    <button v-if="message.type !== 'system'" class="reply-button" @click="startReply(message, index)"
                      title="Auf diese Nachricht antworten">
                      <i class="bi bi-reply"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <div class="formatting-toolbar m-2">
            <div class="d-flex align-items-center">
              <button class="btn btn-format" @click="formatText('bold')" title="Fett">
                <i class="bi bi-type-bold"></i>
              </button>
              <button class="btn btn-format" @click="formatText('italic')" title="Kursiv">
                <i class="bi bi-type-italic"></i>
              </button>
              <button class="btn btn-format" @click="formatText('underline')" title="Unterstrichen">
                <i class="bi bi-type-underline"></i>
              </button>
              <div class="vr mx-2"></div>
              <div class="emoji-picker-wrapper">
                <button class="btn btn-format" @click="toggleEmojiPicker" title="Emoji einfügen">
                  <i class="bi bi-emoji-smile"></i>
                </button>
                <Transition name="fade">
                  <div v-if="showEmojiPicker" class="emoji-picker-container">
                    <EmojiPicker @select="handleEmojiSelect" />
                  </div>
                </Transition>
              </div>
            </div>
          </div>

          <div v-if="activeReply" class="reply-preview">
            <div class="reply-content">
              <div class="reply-header">
                <i class="bi bi-reply-fill me-2"></i>
                <span class="reply-sender">Antwort an {{ activeReply.sender }}</span>
              </div>
              <div v-dompurify-html="activeReply.text" class="reply-text"></div>
            </div>
            <button class="reply-cancel" @click="cancelReply">
              <i class="bi bi-x"></i>
            </button>
          </div>

          <div :v-if="showTypingNotification" class="typing-indicator" v-if="typingMessage">
            <small class="text-muted">{{ typingMessage }}</small>
          </div>

          <div class="overlay-input" :class="{ 'chat-input-disabled': chatInputDisabled }">
            <div class="input-group">
              <div id="input-textfield" tabindex="0" ref="messageInput" class="form-control rich-input" :contenteditable="!chatInputDisabled" autofocus
                style="padding: 0.25rem 0.5625rem" @keydown="handleKeyDown" @keydown.enter.prevent="sendMessage"
                @input="handleInput" @paste="handlePaste">
              </div>
              <button class="btn btn-primary btn-chat send-button" :disabled="!hasValidMessage || chatInputDisabled" @click="sendMessage">
                <i class="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

.emoji-picker-wrapper {
  position: relative;
}

.emoji-picker-container {
  position: absolute;
  bottom: calc(100% + 12px);
  /* Increased to make room for arrow */
  left: 50%;
  transform: translateX(-50%);
  z-index: 1050;
}

/* Add fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 768px) {
  .emoji-picker-container {
    left: -120px;
    transform: none;
  }

  /* Hide arrow on mobile */
  .emoji-picker-arrow {
    display: none;
  }
}

.end-of-chat-warning {
  color: #FFF;
}

.timer {
  font-weight: normal;
  font-size: 1.0625rem;
}

.websocket-alert, .no-user-alert {
  top: 6rem;
}

.overlay-header > div:nth-of-type(1) {
  order: 1;
}

.overlay-header > div:nth-of-type(3) {
  order: 2;
}
.overlay-header > div:nth-of-type(2) {
  order: 3;
}

.end-of-chat-warning {
  min-width: 266px;
}

@media screen and (min-width: 769px) and (max-width: 930px) {
  .overlay-header {
    flex-wrap: wrap;
  }
  .overlay-header > div:nth-of-type(3) {
    order: 3;
  }
}

@media screen and (max-width: 620px) {
  .overlay-header {
    flex-wrap: wrap;
  }
  .overlay-header > div:nth-of-type(3) {
    order: 3;
  }
}

</style>

<script lang="ts">
import EmojiPicker from '@/components/controls/EmojiPicker.vue';
import { UserDto } from '@/generated/openapi';
import LoadingMixin from '@/mixins/LoadingMixin';
import { UserRole } from '@/models/UserRole';
import { sanitizeMessage } from '@/utils/sanitizationUtils';
import JSEncrypt from 'jsencrypt';
import { defineComponent, ref, Ref } from 'vue';
import CONFIG from "../../config/config";
import { encryptSymmetric, decryptSymmetric, arrayBufferToBase64String } from "./WebCryptoApi";
import { TokenStorage } from "@/services/authService";
import settingsService from '@/services/settingsService';

interface PublicKeys {
  [username: string]: string;
}

const SYSTEM_MESSAGES = {
  THIS_CHAT_CLOSED: "Diese Chatverbindung wurde beendet! Bitte schließen Sie den Chat.",
  OTHER_CHAT_CLOSED: "Eine bestehende Chatverbindung wurde beendet.",
}

function translateSystemMessage(systemMessageKeyOrText: string) {
  for(const key of Object.keys(SYSTEM_MESSAGES)) {
    if (systemMessageKeyOrText.includes(`%${key}%`)) {
      return SYSTEM_MESSAGES[(key as keyof typeof SYSTEM_MESSAGES)]
    }
  }
  return systemMessageKeyOrText
}

interface MessageContent {
  text: string;
  replyTo?: CitationData;
}

interface CitationData {
  text: string;
  sender: string;
  messageIndex: number;
  timestamp?: number;
}

interface Message {
  type: 'own-user' | 'other-user' | 'system';
  text: string | number;
  sender: string;
  replyTo?: CitationData;
  timestamp?: number;
}

interface MessageData {
  timestamp: number;
  content: {
    [key: string]: string;
  };
}

interface EncryptedMessage {
  key: string;
  message: string;
  iv: string;
}

interface InputEventLike {
  target: HTMLElement;
}

interface TypingUser {
  username: string;
  timestamp: number;
}

interface UserListItem {
  username: string;
  userType: string;
}

type FormatType = 'bold' | 'italic' | 'underline' | 'remove';

export default defineComponent({
  name: 'ChatControl',

  setup() {
    const messagesContainer: Ref<HTMLElement | null> = ref(null);
    const messageInput: Ref<HTMLElement | null> = ref(null);
    const activeReply: Ref<CitationData | null> = ref(null);
    const selection: Ref<Range | null> = ref(null);

    return {
      messagesContainer,
      messageInput,
      activeReply,
      selection,
    };
  },

  data() {
    return {
      showChat: false,
      username: '',
      roomName: '',
      roomToken: '',
      inputMessage: '',
      messages: [] as Message[],
      publicKey: '',
      privateKey: '',
      otherPublicKeys: {} as Record<string, string>,
      pollingInterval: null as number | null,
      pingInterval: null as number | null,
      userListInterval: null as number | null,
      userList: [] as UserListItem[],
      showEmojiPicker: false,
      showNoUsersAlert: false,
      sidebarActive: false,
      showCloseConfirmation: false,
      previousUserList: [] as string[],
      webSocket: null as WebSocket | null,
      webSocketStatus: 'disconnected' as 'connecting' | 'connected' | 'disconnected' | 'reconnecting',
      webSocketError: null as string | null,
      chatInputDisabled: false,
      reconnectAttempts: 0,
      maxReconnectAttempts: 99,
      reconnectDelay: 2000,
      typingUsers: [] as TypingUser[],
      typingUser: null as string | null,
      typingTimeout: null as number | null,
      showTypingNotification: false,
      lastTypingUpdate: 0,
      minimized: false,
      showMaximizeButton: false,
      appointmentEndTime: ''
    };


  },
  props: {
    showUpdate: { type: Boolean },
  },
  components: { EmojiPicker },
  computed: {
    currentUser(): UserDto {
      return this.$store.state.currentUser;
    },
    isAdmin(): boolean {
      return this.$store.state.activeTenant[0].role === UserRole.ADMIN
    },
    typingMessage(): string {
      if (this.typingUser) return `${this.typingUser} schreibt...`;
      return ''
    },
    hasValidMessage(): boolean {
      if (!this.inputMessage) return false;
      return this.inputMessage.trim().replace(/&nbsp;/g, ' ').replace(/\s/g, '') !== '';
    }
  },
  mixins: [
    LoadingMixin
  ],
  mounted() {
    // setInterval(() => { this.$forceUpdate()}, 1000); // 1000 milliseconds
  },
  methods: {
    countdown() {
      this.updateTimer();
    },
    updateTimer() {
      let element = (this.$refs.timer as HTMLElement),
          hours, mins, msLeft, time;
      msLeft = new Date(this.appointmentEndTime).getTime() - (+new Date);
      if ( msLeft < 1000 ) {
        if (element) {
          element.innerHTML = '';
          const endWarning = (this.$refs.endWarning as HTMLElement);
          if (endWarning) {
            endWarning.innerHTML = 'Das Terminende ist erreicht.';
          }
        }
      } else {
          time = new Date( msLeft );
          hours = time.getUTCHours();
          mins = time.getUTCMinutes();
          if (element) {
            element.innerHTML = (hours ? hours + ':' + this.twoDigits( mins ) : mins) + ':' + this.twoDigits( time.getUTCSeconds() );
          }
          setTimeout( this.updateTimer, time.getUTCMilliseconds() + 500 );
      }
    },
    twoDigits(n: number) {
      return (n <= 9 ? "0" + n : n);
    },
    getMessageCssClassForUser(username: string) {
      let clientIndex = this.userList.filter(u => u.userType !== "ADVISOR").findIndex(u => u.username === username)
      if (clientIndex > -1) {
        return `message-color-name-client-${clientIndex} client`
      } else if (this.userList.find(u => u.username === username)){
        return `message-color-name-advisor advisor`

      }
      else if(username==='SYSTEM'){
        return 'message-system'
      }
    return `message-color-default`
    },

    minimizeChat() {
      this.minimized = true;
      this.showMaximizeButton = true;
      this.$emit('chat-minimized', true);
    },

    maximizeChat() {
      this.minimized = false;
      this.showMaximizeButton = false;
      this.$emit('chat-minimized', false);
    },
    handleEmojiSelect(emoji: any) {
      this.insertEmoji(emoji);
      this.showEmojiPicker = false;
    },
    toggleEmojiPicker() {
      this.showEmojiPicker = !this.showEmojiPicker;
    },
    getWebSocketUrl(): string {
      // Parse the base API URL
      const apiUrl = new URL(CONFIG.wssChatUrl, window.location.origin);

      // Determine WebSocket protocol (wss for HTTPS, ws for HTTP)
      const wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';

      // Construct WebSocket URL using the same host and port as the API
      const wsUrl = `${wsProtocol}//${apiUrl.host}/ws/chat`;

      // console.log('WebSocket URL:', wsUrl);
      return wsUrl;
    },
    async initializeWebSocket(): Promise<void> {
      if (this.webSocket) {
        this.webSocket.close();
      }

      try {
        const wsUrl = this.getWebSocketUrl();
        this.webSocket = new WebSocket(wsUrl);

        this.webSocket.onopen = this.handleWebSocketOpen;
        this.webSocket.onmessage = this.handleWebSocketMessage;
        this.webSocket.onclose = this.handleWebSocketClose;
        this.webSocket.onerror = this.handleWebSocketError;

        this.pingInterval = window.setInterval(this.ping, 60000);

      } catch (error) {
        console.error('Error initializing WebSocket:', error);
        throw error;
        // this.attemptReconnect();
      }
    },
    async handleWebSocketOpen(): Promise<void> {
      console.log('WebSocket connection established');
      this.webSocketStatus = "connected";
      this.chatInputDisabled=false;
      this.reconnectDelay = 1000;

      if (this.currentUser && this.currentUser.roles?.includes('ADVISOR')) {

        const chatToken = await settingsService.getChatToken();

        // Send join message with accessToken and roomToken
        this.sendWebSocketMessage(`JOIN:${chatToken.chatToken}#|#${this.roomToken}`);
      } else {
        let tokenString = sessionStorage.getItem('token');
        if (!tokenString) {
          console.error("No Token available, refreshing page");
          location.reload();
        }
        const token: TokenStorage = JSON.parse(tokenString || "");

        // Send join message with accessToken and roomToken
        this.sendWebSocketMessage(`JOIN:${token.accessToken}#|#${this.roomToken}`);
      }
    },
    handleOtherPublicKeys(otherPublicKeysJson: string): void {
      // console.log('Received user list:', otherPublicKeysJson);
      try {
        const publicKeys: PublicKeys = JSON.parse(otherPublicKeysJson);
        const otherPublicKeys: PublicKeys = {}; // Reset the public keys

        for (const [user, key] of Object.entries(publicKeys)) {
          if (user !== this.username) { // Assuming username is a class property
            otherPublicKeys[user] = key;
          }
        }
        this.otherPublicKeys = otherPublicKeys;
        // console.log('Updated public keys', otherPublicKeys);
      } catch (error) {
        console.error('Error parsing user list:', error);
      }
    },
    handlePublicKey(publicKeyMessage: string): void {
      // console.log('Received public key message:', publicKeyMessage);

      const [user, key] = publicKeyMessage.split(':');

      if (user !== this.username) { // Assuming username is defined in outer scope
        this.otherPublicKeys[user] = key; // Assuming otherPublicKeys is PublicKeys type
        // this.userList.push({ username: user, userType: 'CLIENT' } as UserListItem);
        // console.log('Added public key for', user);
        // console.log('Current public keys:', this.otherPublicKeys);
      }
    },
    async handleWebSocketMessage(event: MessageEvent): Promise<void> {
      const message = event.data;


      try {
        // First check if it's a system or control message
        if (typeof message === 'string') {
          if (message.startsWith('ERROR:')) {
            // this.webSocketError = message.substring(6);
            this.webSocketStatus = 'disconnected';
            //this.chatInputDisabled = true;
            const [sender, message] = event.data.split(':');
            if (message === 'Invalid room token') {
              // ignore this message BOP-823
              return;
            }
            this.appendMessage(sender, message);
            console.error(this.webSocketError);
            return;
          }

          if (message.startsWith('SYSTEM:')) {
            const [sender, message] = (event.data as string).split(':');
            if (message.endsWith('hat den Raum verlassen.')) {
              // remove user from userList: BOP-823
              const username = message.split(' ')[0];
              if (username) {
                this.userList = this.userList.filter(function( obj ) {
                  return obj.username !== username;
                });
              }
            }
            if (message.includes(`%THIS_CHAT_CLOSED%`)) {
              this.chatInputDisabled = true;
            }
            this.appendMessage(sender, translateSystemMessage(message));
            return;
          }

          if (message.startsWith('TYPING:')) {
            const username = message.substring(7);
            this.handleTypingIndicator(username);

            return;
          }

          if (message.startsWith('USER_LIST:')) {
            this.handleUserList(message.substring(10));
            return;
          }

          if (message.startsWith('OWN_KEYS:')) {
            const [publicKey, privateKey] = message.substring(9).split(':');
            this.publicKey = publicKey;
            this.privateKey = privateKey;
            this.otherPublicKeys[this.username] = publicKey;
            // Send public key after receiving own keys
            this.sendWebSocketMessage(`PUBLIC_KEY:${this.publicKey}`);

            this.fetchNewMessages();

            return;
          }

          if (message.startsWith('OTHER_PUBLIC_KEYS:')) {
            this.handleOtherPublicKeys(message.substring(18));
            return;
          }

          if (message.startsWith('PUBLIC_KEY:')) {
            this.handlePublicKey(message.substring(11));
            return;
          }
        }

        // Handle encrypted chat messages
        const messageData = JSON.parse(message);
        const [sender, encryptedMessage] = Object.entries(messageData)[0];

        if (sender !== this.username) {
          const decryptedMessage = await this.decryptMessage(sender, encryptedMessage);
          if (decryptedMessage) {
            this.appendMessage(sender, decryptedMessage);
          } else {
            console.error(`Failed to decrypt message from ${sender}`);
          }
        }
      } catch (error) {
        console.error('Error processing WebSocket message:', error);
        this.webSocketError = 'Error processing message';
      }
    },

    handleWebSocketClose(event: CloseEvent): void {
      this.webSocketStatus = "disconnected"
      console.info('WebSocket connection closed:', event.code, event.reason);
      console.debug('showChat', this.showChat)
      console.debug('webSocketStatus', this.webSocketStatus)
      console.debug('reconnectAttempts', this.reconnectAttempts)
      if (this.showChat && this.reconnectAttempts < this.maxReconnectAttempts) {
        this.attemptReconnect();
      }
    },

    handleWebSocketError(error?: Event): void {
      console.warn('WebSocket error:', error);
      this.webSocketStatus = "disconnected"
      this.chatInputDisabled= true
      // if (this.showChat && this.reconnectAttempts < this.maxReconnectAttempts) {
      //   this.attemptReconnect();
      // }
    },
    handleTypingIndicator(username: string): void {
      // Don't show typing indicator for own messages
      if (username === this.username) return;

      // Clear any existing timeout for this user
      if (this.typingTimeout) {
        clearTimeout(this.typingTimeout);
      }

      // Set the typing user and show notification
      this.typingUser = username;
      this.showTypingNotification = true;

      // Clear the typing indicator after a delay (3 seconds)
      this.typingTimeout = window.setTimeout(() => {
        this.typingUser = null;
        this.showTypingNotification = false;
      }, 3000);
    },

    attemptReconnect(): void {
      this.webSocketStatus = "reconnecting"
      this.chatInputDisabled=true
      this.reconnectAttempts++;

      console.log(`Attempting to reconnect (${this.reconnectAttempts}/${this.maxReconnectAttempts})`);
      setTimeout(() => {

        this.initializeWebSocket();
        // Exponential backoff for reconnect delay
        this.reconnectDelay = Math.min(this.reconnectDelay * 2, 30000);
      }, this.reconnectDelay);

    },

    sendWebSocketMessage(message: string): void {
      try {
        if (this.webSocket) {
          this.webSocket.send(message)
        } else {
          this.handleWebSocketError()
        }
      } catch(e: any) {
        this.handleWebSocketError(e)
      }
    },
    generateRandomRoomName(): string {
      const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      const crypto = window.crypto || undefined;
      const array = new Uint32Array(1);
      crypto?.getRandomValues(array);
      const randomNumber = array[0];
      for (let i = 0; i < 10; i++) {
        result += chars.charAt(Math.floor(randomNumber * chars.length));
      }
      return result;
    },
    toggleSidebar() {
      this.sidebarActive = !this.sidebarActive;
    },
    async openChat(token: string, username = '', appointmentEndTime?: string): Promise<void> {
      try {
        this.roomToken = token;
        this.minimized = false;
        this.showMaximizeButton = false;
        if (appointmentEndTime) {
          this.appointmentEndTime = appointmentEndTime;
        }

        this.username = username || this.currentUser.name || ''
        this.webSocketStatus = "connecting"
        this.chatInputDisabled=false
        await this.initializeWebSocket();
        // Show the chat UI
        this.showChat = true;
        this.$nextTick(() => {
          this.scrollToBottom();
          document.getElementById("input-textfield")?.focus();
        });
      } catch (error) {
        console.error('Error opening chat:', error);
      }
    },

    async typing(): Promise<void> {
      this.sendWebSocketMessage(`TYPING`);
    },

    async ping(): Promise<void> {
      this.sendWebSocketMessage(`PING`);
    },

    async fetchNewMessages(): Promise<void> {
      try {
        const response = await fetch(`${CONFIG.baseApiUrl}e2echat/messages/${this.roomToken}/${this.username}`, {
          headers: {
            "X-Requested-With": "XMLHttpRequest"
          }
        });
        const messages = await response.json() as MessageData[];
        this.messages = [] as Message[];

        for (const messageData of messages) {

          // console.log(messageData);

          const [sender, encryptedContent] = Object.entries(messageData.content)[0];

          // console.log(sender);
          // console.log(encryptedContent);

          try {
            const recipientMessages = JSON.parse(encryptedContent);

            // console.log(recipientMessages);

            const userMessage = recipientMessages[this.username];

            // console.log(userMessage);

            if (!userMessage) {
              console.error('No message found for current user');
              continue;
            }

            // const encryptedPackage = JSON.parse(userMessage);

            const decryptedMessage = await this.decryptMessage(sender, userMessage);
            if (decryptedMessage) {
              this.appendMessage(sender, decryptedMessage);
            } else {
              console.error(`Failed to decrypt message from ${sender}`);
              this.appendMessage(sender, '[Error: Unable to decrypt message]');
            }

          } catch (parseError) {
            console.error('Error parsing message content:', parseError);
            continue;
          }
        }
      } catch (error) {
        console.error('Error fetching messages:', error);
      }
    },

    async fetchUserList(): Promise<void> {
      try {
        const response = await fetch(`${CONFIG.baseApiUrl}e2echat/users/${this.roomToken}`, {
          headers: {
            "X-Requested-With": "XMLHttpRequest"
          }
        });
        const userList = await response.json() as Record<string, string>;
        this.handleUserList(JSON.stringify(userList));
      } catch (error) {
        console.error('Error fetching user list:', error);
      }
    },

    startReply(message: Message, index: number): void {
      if (this.activeReply?.messageIndex === index) {
        this.cancelReply();
        return;
      }

      this.activeReply = {
        text: message.text=== typeof "string" ? message.text.trim().replaceAll('&nbsp;',' ') : message.text.toString(),
        sender: message.type === 'own-user' ? this.username : message.sender || 'Unknown',
        messageIndex: index,
        timestamp: message.timestamp
      };

      this.$nextTick(() => {
        this.messageInput?.focus();
      });
    },

    cancelReply(): void {
      this.activeReply = null;
    },

    async sendMessage(): Promise<void> {
      if (!this.messageInput) return;

      const input = this.messageInput;
      const trimmedInput = input.innerHTML.trim();

      // Check if input is empty or only contains spaces/nbsp
      if (!trimmedInput || trimmedInput.replace(/&nbsp;/g, ' ').replace(/\s/g, '') === '') return;

      // Sanitize the input message
      this.inputMessage = sanitizeMessage(input.innerHTML).trim().replaceAll('&nbsp;',' ');

      this.appendMessage(this.username, this.inputMessage, this.activeReply||undefined);


      try {
        const messageContent: MessageContent = {
          text: this.inputMessage,
          replyTo: this.activeReply || undefined
        };

        const encryptedMessages = await this.encryptForAllRecipients(JSON.stringify(messageContent));
        if (!encryptedMessages) {
          throw new Error("Failed to encrypt messages");
        }

        // Send encrypted messages via WebSocket
        this.sendWebSocketMessage(JSON.stringify(encryptedMessages));

        // Clear the input completely
        input.innerHTML = '';
        this.inputMessage = '';
        this.activeReply = null;



        // Reset any saved selection
        const selection = window.getSelection();
        if (selection) {
          selection.removeAllRanges();
        }
      } catch (error) {
        console.error('Error sending message:', error);
      }

      this.focusElement(this.$refs.messageInput as HTMLElement);
      //this.handleInput({ target: input });
     // this.messageInput?.focus();
    },
    focusElement(element: any) {
        let range, selection;
        if (document.createRange) {
            range = document.createRange();
            range.selectNodeContents(element);
            range.collapse(false);
            selection = window.getSelection();
            selection?.removeAllRanges();
            selection?.addRange(range);
        }
    },
    appendMessage(sender: string, message: string, activeReply?: CitationData): void {
      try {
        const messageData = JSON.parse(message) as MessageContent;
        const newMessage: Message = {
          type: sender === this.username ? 'own-user' : sender === 'SYSTEM' ? 'system' : 'other-user',
          text: messageData.text === typeof "string" ? messageData.text : messageData.text.toString(),
          sender: sender,
          replyTo: messageData.replyTo,
          timestamp: Date.now()
        };
        this.messages.push(newMessage);
      } catch (e) {
        // Fallback for plain text messages
        const newMessage: Message = {
          type: sender === this.username ? 'own-user' : sender === 'SYSTEM' ? 'system' : 'other-user',
          text: message,
          sender: sender,
          replyTo: activeReply,
          timestamp: Date.now()
        };

        this.messages.push(newMessage);
      }
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },

    handleUserList(userListJson: string): void {
      try {
        const userList = JSON.parse(userListJson);
        this.userList = userList;
      } catch (error) {
        console.error('Error parsing user list:', error);
      }
    },

    async encryptForAllRecipients(message: string): Promise<Record<string, string> | null> {
      try {
        const encryptedMessages: Record<string, string> = {};

        // Encrypt for other recipients
        // console.log(this.otherPublicKeys);
        for (const [recipientUsername, recipientPublicKey] of Object.entries(this.otherPublicKeys)) {
          // console.log(recipientUsername);
          // console.log(recipientPublicKey);
          const encrypted = await this.encryptForRecipient(message, recipientPublicKey);
          if (!encrypted) throw new Error(`Failed to encrypt for recipient ${recipientUsername}`);
          encryptedMessages[recipientUsername] = encrypted;
        }

        // Encrypt for self
        const selfEncrypted = await this.encryptForRecipient(message, this.publicKey);
        if (!selfEncrypted) throw new Error('Failed to encrypt for self');
        encryptedMessages[this.username] = selfEncrypted;

        // console.log(encryptedMessages);
        return encryptedMessages;
      } catch (error) {
        console.error('Error in encryptForAllRecipients:', error);
        return null;
      }
    },

    async encryptForRecipient(message: string, recipientPublicKey: string): Promise<string | null> {
      try {
        let decoder = new TextDecoder('utf8');
        var aesKey = arrayBufferToBase64String(crypto.getRandomValues(new Uint8Array(32)).buffer);
        const encryptedAesKey = this.encryptWithRsa(aesKey, recipientPublicKey);
        if (!encryptedAesKey) {
          throw new Error("Failed to encrypt AES key");
        }
        const {
          ciphertext,
          iv
        } = await encryptSymmetric(message, aesKey);

        const messagePackage: EncryptedMessage = {
          key: encryptedAesKey,
          message: ciphertext,
          iv: iv
        };

        return JSON.stringify(messagePackage);
      } catch (error) {
        console.error('Error encrypting message:', error);
        return null;
      }
    },
    async decryptMessage(sender: string, encryptedData: any): Promise<string | null> {
      try {
        const parsedData = JSON.parse(encryptedData) as EncryptedMessage;

        // console.log(parsedData);
        // console.log(sender);

        const { key: encryptedAesKey, message: encryptedMessage, iv: iv } = parsedData;

        const aesKey = this.decryptWithRsa(encryptedAesKey);
        if (!aesKey) {
          throw new Error("Failed to decrypt AES key");
        }

        const decryptedMessage = await decryptSymmetric(encryptedMessage, iv, aesKey);

        // const decryptedBytes = CryptoJS.AES.decrypt(encryptedMessage, aesKey);
        // const decryptedMessage = decryptedBytes.toString(CryptoJS.enc.Utf8);
        if (!decryptedMessage) {
          throw new Error("Decryption resulted in empty message");
        }

        return decryptedMessage;
      } catch (error) {
        console.error("Error in decryptMessage:", error);
        return null;
      }
    },

    encryptWithRsa(data: string, publicKey: string): string | null {
      try {
        const encrypt = new JSEncrypt();
        encrypt.setPublicKey(publicKey);
        const encrypted = encrypt.encrypt(data);
        if (!encrypted) {
          throw new Error("RSA encryption failed");
        }
        return encrypted;
      } catch (error) {
        console.error("Error in encryptWithRsa:", error);
        return null;
      }
    },

    decryptWithRsa(data: string): string | null {
      try {
        const decrypt = new JSEncrypt();
        decrypt.setPrivateKey(this.privateKey);
        const decrypted = decrypt.decrypt(data);
        if (!decrypted) {
          throw new Error("RSA decryption failed");
        }
        return decrypted;
      } catch (error) {
        console.error("Error in decryptWithRsa:", error);
        return null;
      }
    },

    formatText(format: FormatType): void {
      if (!this.$refs.messageInput) return;

      // debugger;
      const selection = window.getSelection();
      if (!selection || !selection.rangeCount) return;

      const range = selection.getRangeAt(0);
      if (range.collapsed) return;
      
      let elementTag = "";

      if (format === 'bold') {
        elementTag = 'b';
      } else if (format === 'italic') {
        elementTag = 'i';
      } else if (format === 'underline') {
        elementTag = 'u';
      } else {
        return
      }

      if (elementTag === 'b') {
        document.execCommand("bold", false, undefined);
      } else if (elementTag === 'i') {
        document.execCommand('italic', false, undefined);
      } else if (elementTag === 'u') {
        document.execCommand('underline', false, undefined);
      }      
      //(this.$refs.messageInput as HTMLElement).focus();

      // Update input message with the new interface
      //this.handleInput({ target: this.$refs.messageInput as HTMLElement });
    },
    preserveTrailingSpace(content: string): string {
      // Check for one or more trailing non-breaking spaces
      const trailingSpaces = content.match(/(?:&nbsp;)+$/);
      if (trailingSpaces) {
        return content;
      }
      // Check for one or more trailing regular spaces
      const trailingRegularSpaces = content.match(/\s+$/);
      if (trailingRegularSpaces) {
        // Replace trailing regular spaces with non-breaking spaces
        return content.replace(/\s+$/, match => '&nbsp;'.repeat(match.length));
      }
      return content;
    },


    handleInput(event: Event | InputEventLike): void {
      const target = event instanceof Event ? event.target as HTMLElement : event.target;

      // Save current selection before any modifications
      const selection = window.getSelection();
      const range = selection?.getRangeAt(0);
      const isAtEnd = range && this.isSelectionAtEnd(target);

      // Get current content
      let content = target.innerHTML;

      // Sanitize while preserving trailing spaces
      const sanitized = this.preserveTrailingSpace(sanitizeMessage(content));

      this.inputMessage = sanitized;

      // Only update if content changed
      if (target.innerHTML !== sanitized) {
        target.innerHTML = sanitized;

        // Restore cursor to end if it was at end
        if (isAtEnd) {
          this.setCaretToEnd(target);
        }
      }

      // Throttle typing notifications
      const now = Date.now();
      if (now - this.lastTypingUpdate > 1000) {
        this.typing();
        this.lastTypingUpdate = now;
      }
    },

    isSelectionAtEnd(element: HTMLElement): boolean {
      const selection = window.getSelection();
      if (!selection || !selection.rangeCount) return false;

      const range = selection.getRangeAt(0);
      const clone = range.cloneRange();
      clone.selectNodeContents(element);
      clone.setStart(range.endContainer, range.endOffset);

      return clone.toString().trim().length === 0;
    },

    setCaretToEnd(element: HTMLElement): void {
      const range = document.createRange();
      const selection = window.getSelection();

      // Find the last text node
      let lastTextNode = element;
      const walker = document.createTreeWalker(
        element,
        NodeFilter.SHOW_TEXT,
        null
      );

      // Fix the ESLint error by separating assignment from condition
      let node = walker.nextNode();
      while (node !== null) {
        lastTextNode = node as HTMLElement;
        node = walker.nextNode();
      }

      if (lastTextNode) {
        range.setStartAfter(lastTextNode);
        range.collapse(true);

        if (selection) {
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
    },

    restoreSelection(savedSel: { start: number, end: number } | null, target: HTMLElement): void {
      if (!savedSel) return;

      const selection = window.getSelection();
      if (!selection) return;

      // Find the positions to restore
      const [startNode, startOffset] = this.getNodeAndOffsetFromCharacterOffset(target, savedSel.start);
      const [endNode, endOffset] = this.getNodeAndOffsetFromCharacterOffset(target, savedSel.end);

      if (!startNode || !endNode) return;

      const range = document.createRange();
      range.setStart(startNode, startOffset);
      range.setEnd(endNode, endOffset);

      selection.removeAllRanges();
      selection.addRange(range);
    },

    getCaretCharacterOffset(element: HTMLElement, node: Node, offset: number): number {
      let charCount = 0;
      const walk = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);

      while (walk.nextNode()) {
        const textNode = walk.currentNode;
        if (textNode === node) {
          return charCount + offset;
        }
        charCount += textNode.textContent?.length || 0;
      }

      return charCount;
    },

    getNodeAndOffsetFromCharacterOffset(element: HTMLElement, offset: number): [Node | null, number] {
      let charCount = 0;
      const walk = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);

      while (walk.nextNode()) {
        const textNode = walk.currentNode;
        const length = textNode.textContent?.length || 0;

        if (charCount + length >= offset) {
          return [textNode, offset - charCount];
        }

        charCount += length;
      }

      return [null, 0];
    },

    saveSelection(): { start: number, end: number } | null {
      const selection = window.getSelection();
      if (!selection || !selection.rangeCount || !this.$refs.messageInput) return null;

      const range = selection.getRangeAt(0);
      const input = this.$refs.messageInput as HTMLElement;

      // Only save selection if it's within our input
      if (!input.contains(range.commonAncestorContainer)) return null;

      return {
        start: this.getCaretCharacterOffset(input, range.startContainer, range.startOffset),
        end: this.getCaretCharacterOffset(input, range.endContainer, range.endOffset)
      };
    },

    handleKeyDown(event: KeyboardEvent): void {
      if (event.key === ' ') {
        event.preventDefault();

        const selection = window.getSelection();
        if (!selection || !selection.rangeCount) return;

        const range = selection.getRangeAt(0);
        const nbsp = document.createTextNode('\u00A0');

        range.deleteContents();
        range.insertNode(nbsp);

        // Move cursor after inserted space
        range.setStartAfter(nbsp);
        range.setEndAfter(nbsp);
        selection.removeAllRanges();
        selection.addRange(range);

        // Force content update
        if (this.$refs.messageInput) {
          const input = this.$refs.messageInput as HTMLElement;
          this.handleInput({ target: input });
        }
      }
    },

    handlePaste(event: ClipboardEvent): void {
      event.preventDefault();
      const text = event.clipboardData?.getData('text/plain');
      if (!text || !this.$refs.messageInput) return;

      // Sanitize the pasted content first
      const sanitizedText = sanitizeMessage(text);
      const input = this.$refs.messageInput as HTMLElement;
      const selection = window.getSelection();

      // If there's no selection, append to the end
      if (!selection || !selection.rangeCount) {
        const range = document.createRange();
        range.selectNodeContents(input);
        range.collapse(false);
        selection?.removeAllRanges();
        selection?.addRange(range);
      }

      const range = selection?.getRangeAt(0);
      if (range) {
        // If the text contains any HTML-like content that survived sanitization,
        // we need to create a temporary element to parse it properly
        const temp = document.createElement('div');
        temp.innerHTML = sanitizedText;

        // Delete existing content in the range
        range.deleteContents();

        // Insert each node from the sanitized content
        Array.from(temp.childNodes).forEach(node => {
          range.insertNode(node.cloneNode(true));
        });

        // Move cursor to end of inserted text
        range.collapse(false);
        selection?.removeAllRanges();
        selection?.addRange(range);
      }

      // Normalize the input content (remove empty text nodes, etc.)
      input.normalize();

      // Make sure the final content is sanitized again
      const finalContent = sanitizeMessage(input.innerHTML);
      if (input.innerHTML !== finalContent) {
        input.innerHTML = finalContent;

        // Reset cursor to end
        const range = document.createRange();
        range.selectNodeContents(input);
        range.collapse(false);
        selection?.removeAllRanges();
        selection?.addRange(range);
      }

      // Trigger input handler to process the new content
      this.handleInput({ target: input });
    },

    insertEmoji(emoji: string): void {
      if (!this.$refs.messageInput) return;

      const input = this.$refs.messageInput as HTMLElement;
      const selection = window.getSelection();

      // Always focus the input first
      input.focus();

      // Get current selection or create new one at the end
      if (selection) {
        let range: Range;

        // If there's no selection in the input, create one at the end
        if (!selection.rangeCount || !input.contains(selection.getRangeAt(0).commonAncestorContainer)) {
          range = document.createRange();
          range.selectNodeContents(input);
          range.collapse(false); // Collapse to end
          selection.removeAllRanges();
          selection.addRange(range);
        } else {
          range = selection.getRangeAt(0);
        }

        // Insert the emoji
        const textNode = document.createTextNode(emoji);
        range.insertNode(textNode);

        // Move cursor after emoji
        range.setStartAfter(textNode);
        range.setEndAfter(textNode);
        selection.removeAllRanges();
        selection.addRange(range);
      } else {
        // Fallback: just append to the end
        input.appendChild(document.createTextNode(emoji));
      }

      this.showEmojiPicker = false;
      this.handleInput({ target: input });
    },

    scrollToBottom(): void {
      if (this.messagesContainer) {
        this.messagesContainer.scrollTop = this.messagesContainer.scrollHeight;
      }
    },

    initiateClose() {
      this.showCloseConfirmation = true;
    },

    handleCloseConfirmation(confirmed: boolean) {
      if (confirmed) {
        this.closeChat();
      }
      this.showCloseConfirmation = false;
    },
    async closeChat(): Promise<void> {
      this.showChat = false;
      this.$emit('chat-closed')
      if (this.webSocket) {
        this.webSocket.close();
        this.webSocket = null;
      }
      if (this.pingInterval) {
        clearInterval(this.pingInterval)
      }

      this.webSocketStatus = "disconnected"
      this.messages = [];
      this.minimized = false;
      this.roomToken='';
      this.showMaximizeButton = false;
    },
    endsInFiveMinutes() {
      if (this.appointmentEndTime) {
        const endTimeInMillis = new Date(this.appointmentEndTime).getTime();
        if ((endTimeInMillis - Date.now()) <= (5 * 60 * 1000)) {
          this.$nextTick().then(() => {
            this.countdown();
          });
        }
        return (endTimeInMillis - Date.now()) <= (5 * 60 * 1000);
      }
      return false;
    }
  },
  beforeUnmount() {
    this.closeChat();
  }
});
</script>
